/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(".Footer__Title").click(function () {
  let visible = $(this)
    .parents(".Footer__Block--links")
    .children("ul")
    .css("display");
  if (visible == "none") {
    $(this).parents(".Footer__Block--links").children("ul").slideDown();
  } else {
    $(this).parents(".Footer__Block--links").children("ul").slideUp();
  }
});

/*
$('.Header__MainNav .HorizontalList__Item a').each(function(){
  let text = $(this).text().trim().toLowerCase();
  if(text.includes('rebajas')){
    $(this).css('color','#e44f40')
  }
})
$('.Drawer__Main .Collapsible a').each(function(){
  let text = $(this).text().trim().toLowerCase();
  if(text.includes('rebajas')){
    $(this).css('color','#e44f40')
  }
})
*/

function addUpsell(variant_id) {
  data = {
    id: variant_id,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    },
  });
}

$(".horizontal-filter").click(function () {
  if ($(this).css("font-weight") == "700") {
    $(this).css("font-weight", "inherit");
  } else {
    $(this).css("font-weight", "700");
  }
});

$(".sub-menu span").click(function () {
  if ($(this).parents(".sub-menu").find(".sub").css("height") == "0px") {
    $(this).parents(".sub-menu").find(".sub").css("height", "inherit");
    $(this).parents(".sub-menu").find(".sub").addClass("pt-2");
  } else {
    $(this).parents(".sub-menu").find(".sub").css("height", "0px");
    $(this).parents(".sub-menu").find(".sub").removeClass("pt-2");
  }
});
